module.exports = __webpack_public_path__ + "img/c3-m.d15d7eb1.jpg";